import { Injectable } from '@angular/core';
import { EntityCollectionServiceBase, EntityCollectionServiceElementsFactory } from '@ngrx/data';
import { RdSAPLookupCodeDtoV0 } from '../../../rdsap/models/rdsap/rdSAPLookupCodeDtoV0';

// Define the custom entity collection service
// This service is used to provide access to the RdSAPLookUpCodes data service
@Injectable({ providedIn: 'root' })
export class RdSAPLookUpCodesService extends EntityCollectionServiceBase<RdSAPLookupCodeDtoV0> {
  constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory) {
    super('RdSAPLookUpCodes', serviceElementsFactory);
  }
}
